import getProxyPhone, { getPhoneMask, getWhatsAppProxy } from './proxy-phone';

export default getProxyPhone;
export { getPhoneMask, getWhatsAppProxy };
